import { isNil } from "lodash";
import { useEffect } from "react";
import { useTranslation } from "src/hooks";

import { SingleSelection } from "../../GeneralSelection";
import useQueryWalletVersion from "./hooks/useQueryWalletVersion";
import {
  MerchantChainConfigStatus,
  WalletSmartAccountType,
} from "@wallet-manager/node-types/dist/src/postgres/const";
import { getOne } from "./WalletVersionProvider";

type WalletVersionSingleSelectionProps = {
  value: string;
  onChange: (value: string) => void;
  chainType: number | undefined;
  chainId?: number;
  smartAccountType?: WalletSmartAccountType;
  walletEnableStatus?: MerchantChainConfigStatus;
  walletTypes?: (string | number)[];
  disableCleanValueEffect?: boolean;
  customLabel?: string;
};

function WalletVersionSingleSelection({
  value,
  onChange,
  chainType,
  chainId,
  smartAccountType,
  walletTypes,
  walletEnableStatus,
  disableCleanValueEffect,
  customLabel,
}: WalletVersionSingleSelectionProps) {
  const { tc } = useTranslation("common");

  const { walletVersions, rawResponseList } = useQueryWalletVersion({
    chainType,
    chainId,
    smartAccountType,
    walletTypes,
    walletEnableStatus,
  });

  useEffect(() => {
    if (disableCleanValueEffect) return;

    onChange("");
  }, [walletVersions]);

  const walletVersionNameFunc = (item: string) => {
    const target = getOne(rawResponseList, {
      chainType,
      walletVersion: item,
    });

    return `${item}${target?.description ? `(${target.description})` : ""}`;
  };

  return (
    <SingleSelection
      label={customLabel || tc("phSelection", { fieldName: tc("version") })}
      value={value}
      onChange={(e) => onChange(e.target.value)}
      clearSelect={() => onChange("")}
      enumData={walletVersions}
      disabled={isNil(chainType)}
      nameFn={walletVersionNameFunc}
    />
  );
}

export default WalletVersionSingleSelection;
